import React, { FC } from 'react';

import { useTranslation } from 'next-i18next';
import ListingCardPlaceholderList from 'src/admin/listing-editor/components/ListingCardPlaceholderList';
import ListingCardList from 'src/common/components/ListingCardList';
import { ListingCardBoat } from 'src/common/types';
import { Breadcrumb } from 'src/common/types/api/v4/boats/search';
import { usePreviewModeContext } from 'src/common/providers/PreviewModeProvider';

import styles from './SimilarListings.module.scss';

export type SimilarListingsProps = {
  parentBreadcrumbs: Breadcrumb[];
  listings: ListingCardBoat[];
};

const SimilarListings: FC<SimilarListingsProps> = ({
  parentBreadcrumbs,
  listings,
}) => {
  const [t] = useTranslation('listing-page');
  const { previewMode } = usePreviewModeContext();

  if (!previewMode && listings.length === 0) {
    return null;
  }

  return (
    <>
      <h3 className={styles.subTitle}>
        {t('similar-listings')}
      </h3>
      {!previewMode && (
        <ListingCardList
          listings={listings}
          parentBreadcrumbs={parentBreadcrumbs}
          classNameModifier="similarListings"
          enableFetchPriority={false}
          cardLocation="listing page"
        />
      )}
      {previewMode && (
        <ListingCardPlaceholderList />
      )}
    </>
  );
};

export default SimilarListings;
